// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './app'
import router from '../../router/notice/notice'
import echarts from 'echarts'
import ElementUI from 'element-ui'
/**
 * 引入公用样式
 */
import 'res/css/bootstrap.min.css?v=3.3.6'
import 'res/css/font-awesome.min.css?v=4.4.0'
import 'res/css/animate.css'
import 'res/css/style.css?v=4.1.0'
import 'element-ui/lib/theme-chalk/index.css'
import 'res/css/bthStyle.css'

 /**
 * 引入全局js
 */
import 'res/js/jquery.min.js?v=2.1.4'
import 'res/js/bootstrap.min.js?v=3.3.6'
// import 'res/js/plugins/layer/layer.min.js'

import VueHtml5Editor from 'vue-html5-editor'

/**
 * 引入自定义js
 */
// import 'res/js/welcome.js'

 /**
 * 引入第三方插件js
 */
// import 'res/js/plugins/pace/pace.min.js'

Vue.config.productionTip = false

Vue.use(ElementUI)
Vue.prototype.$echarts = echarts
/* eslint-disable no-new */

Vue.use(VueHtml5Editor, {
    // specify your language here
  showModuleName: false,
    // 配置图片模块
    // config image module
  // image: {
    //     // 文件最大体积，单位字节  max file size
    //     sizeLimit: 512 * 1024,
    //     // 上传参数,默认把图片转为base64而不上传
    //     // upload config,default null and convert image to base64
    // upload: {
    //   url: Vue.prototype.$api.config.apiHostKhs + 'order/commodity/uploadFile.do',
    //   headers: {
    //     'Haiziguo-Token': localStorage.getItem('Haiziguo-Token')
    //   },
    //   params: {'uploadType': 1},
    //   fieldName: 'file'
    // },
    //     // 压缩参数,默认使用localResizeIMG进行压缩,设置为null禁止压缩
    //     // compression config,default resize image by localResizeIMG (https://github.com/think2011/localResizeIMG)
    //     // set null to disable compression
        // compress: {
        //     width: 1600,
        //     height: 1600,
        //     quality: 80
        // },
    //     // 响应数据处理,最终返回图片链接
    //     // handle response data，return image url
    // uploadHandler (responseText) {
    //   var json = JSON.parse(responseText)
    //   if (json.success == true) {
    //     return json.body
    //   } else {
    //     self.$message(json.msg)
    //   }
    // }
 // },
  language: 'zh-cn',
  il8n: {
    'zh-cn': {
      'align': '对齐方式',
      'list': '列表',
      'link': '链接',
      'unlink': '去除链接',
      'table': '表格',
      'font': '文字',
      'full screen': '全屏',
      'text': '排版',
      'eraser': '格式清除',
      'info': '关于',
      'color': '颜色',
      'please enter a url': '请输入地址',
      'create link': '创建链接',
      'bold': '加粗',
      'italic': '倾斜',
      'underline': '下划线',
      'strike through': '删除线',
      'subscript': '上标',
      'superscript': '下标',
      'heading': '标题',
      'font name': '字体',
      'font size': '文字大小',
      'left justify': '左对齐',
      'center justify': '居中',
      'right justify': '右对齐',
      'ordered list': '有序列表',
      'unordered list': '无序列表',
      'fore color': '前景色',
      'background color': '背景色',
      'row count': '行数',
      'column count': '列数',
      'save': '确定',
      'upload': '上传',
      'progress': '进度',
      'unknown': '未知',
      'please wait': '请稍等',
      'error': '错误',
      'abort': '中断',
      'reset': '重置'
    }
  },
  hiddenModules: [
    'full-screen',
    'info',
    'image'
  ]
})

new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/module/notice/notice.js